import { logFeature } from '@office-start/telemetry-service';
import { DataSecurityLevel, } from '@office-start/telemetry-types';
export function logFetchConfigInternalFinished(params) {
    logFeature({
        featureName: "ConfigQueryWrapper" /* KnownFeatureNames.ConfigQueryWrapper */,
        eventName: 'FetchConfigInternalFinished',
        params: params,
    }, DataSecurityLevel.Security, true);
}
//# sourceMappingURL=logFetchConfigInternalFinished.js.map